<div class="container">
  <router-outlet></router-outlet>
</div>
<app-loader></app-loader>
